import { createSelector } from 'reselect'

const flipgridSelector = state => state.flipgrid

const creationToolSaveSelector = createSelector(
	[
		flipgridSelector,
	],
	flipgridState => (
		{
			teacherUrl: flipgridState.teacherUrl,
			studentUrl: flipgridState.studentUrl,
			entityUid: flipgridState.entityUid,
		}
	)
)

export default creationToolSaveSelector
